export default "__VITE_ASSET__B7qGSQ8O__"